import * as React from "react";

interface IOwnProps {
  containerRef?: React.RefObject<HTMLElement>;
  margin?: string;
  threshold?: number | number[];
  children: (outside: boolean) => any;
}

const styles = {
  height: "0px",
  width: "0px"
};

const LeavesViewport = ({ containerRef, margin: rootMargin = "0px", threshold = [0, 1], children }: IOwnProps) => {
  const elemRef = React.useRef<HTMLDivElement>(null);
  const [isOutside, setOutside] = React.useState(false);
  const [observer, setObserver] = React.useState<IntersectionObserver | null>(null);

  const handleIntersection = React.useCallback(
    entries => {
      const elem = entries[0];
      setOutside(elem.intersectionRatio === 0);
    },
    [setOutside]
  );

  React.useEffect(() => {
    if (elemRef.current) {
      const options = {
        root: containerRef && containerRef.current ? containerRef.current : null,
        rootMargin,
        threshold
      };

      const newObserver = new IntersectionObserver(handleIntersection, options);
      newObserver.observe(elemRef.current);
      setObserver(newObserver);
    }

    return () => {
      if (observer) {
        observer.disconnect();
      }
    };
  }, [containerRef, elemRef]);

  return (
    <>
      <div ref={elemRef} style={styles} />
      {children(isOutside)}
    </>
  );
};

export default React.memo(LeavesViewport);
